<template>
    <b-modal
            centered
            no-close-on-backdrop
            v-model="show"
            size="lg"
            @hide="closeModal(false)"
    >
        <template v-slot:modal-header="{ close }">
            <div class="w-100 ">
                <v-container fluid class="py-0 pl-4 pr-2">
                    <v-row no-gutters>
                        <v-col>
                            <div class="request-number">Заявка № {{detailedItem!=null?detailedItem.requestNumber:''}}</div>
                            <div class="request-date">от {{detailedItem!=null?formatTimeDateMounthName(detailedItem.requestDateTime):''}}</div>

                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-btn @click="closeModal(false)" icon><v-icon>close</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-container>

            </div>
        </template>
        <v-container class="py-0">
            <v-row class="my-2">
                <v-col cols="auto">
                    <v-avatar class="m-auto"
                              size="40"
                              color="teal"
                    >
                        <img
                                v-if="detailedItem!=null&&detailedItem.clientLogo!=null"
                                :src="$root.docsUrl+detailedItem.clientLogo"
                        >
                       <img v-else src="../../assets/noavatar.png" height="40" width="40"/>
                    </v-avatar>
                </v-col>
                <v-col>
                    <div class="client-name">{{detailedItem!=null?detailedItem.clientFullName:''}}</div>
                    <div v-if="detailedItem!=null" :class="{'client-st1':detailedItem.clientStatusCode=='CS01','client-st2':detailedItem.clientStatusCode=='CS02','client-st4':detailedItem.clientStatusCode=='CS04'}">{{detailedItem.clientStatusName}}</div>
                </v-col>
            </v-row>

            <requestDetail :code="detailedItem!=null?detailedItem.requestCategoryCode:null" :requestId="detailedItem!=null?detailedItem.id:null"></requestDetail>
        </v-container>
        <template v-slot:modal-footer="{ cancel }" >
            <div class="w-100 detailFooter" v-if="isArchive==true">
                <v-row >
                    <v-spacer></v-spacer>
                    <b-col cols="auto" class="py-0 my-0">
                        <v-btn
                                color="var(--color-2)"
                                outlined
                                @click="closeModal(false)"
                        >Отмена</v-btn>
                    </b-col>
                </v-row>
            </div>
            <div class="w-100 detailFooter" v-if="isArchive==false&&detailedItem!=null&&detailedItem.requestCategoryCode!='RC04'">
                <template v-if="detailedItem.requestAnswerId==null">
                    <v-container class="py-0">
                        <div class="answer-header">Ваш ответ</div>
                        <v-row >
                            <v-col>
                                <div class="answer-label">Текст ответа</div>
                                <v-textarea
                                        v-model="requestAnswerModel.textAnswer"
                                        rows="4"
                                        placeholder="Предложите способ решения проблемы"
                                        trim
                                        solo
                                        hide-details
                                />
                            </v-col>
                        </v-row >
                        <v-row>
                            <v-col>
                                <div class="answer-label">Стоимость работ</div>
                                <v-text-field
                                        id="input-1"
                                        v-model="requestAnswerModel.priceFrom"
                                        min="0"
                                        hide-details
                                        type="number"
                                        placeholder="От"
                                        trim
                                        dense
                                        solo
                                        style="float: left; margin-right: 10px"

                                />
                                <v-text-field
                                        id="input-2"
                                        v-model="requestAnswerModel.priceTo"
                                        min="0"
                                        hide-details
                                        type="number"
                                        placeholder="До (не обязательно)"
                                        trim
                                        dense
                                        solo
                                        style="float: left"
                                />
                            </v-col>
                        </v-row>
                        <div class="info-label">Ответ клиента отобразится как новый заказ</div>
                    </v-container>
                    <v-divider></v-divider>
                    <v-row >
                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="py-0 my-0">
                            <v-btn
                                    @click="declineRequest(detailedItem.id)"
                                    outlined
                                    color="var(--color-red)"
                                    size="sm"
                            >
                                Отказаться и удалить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto" class="py-0 my-0">
                            <v-btn
                                    dark
                                      color="var(--color-blue)"
                                      @click="onAcceptRequest"
                            >Отправить</v-btn>
                        </v-col>
                        <v-col cols="auto" class="py-0 my-0">
                            <v-btn
                                    outlined
                                    color="var(--color-2)"
                                      @click="closeModal(false)"
                            >Отмена</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <v-container class="py-0">
                        <div class="answer-header">Ваш ответ</div>
                        <v-row >
                            <v-col>
                                <div class="answer-label">Текст ответа</div>
                                <div class="answer-text">
                                    {{detailedItem.requestAnswerText}}
                                </div>
                            </v-col>
                        </v-row >
                        <v-row>
                            <v-col>
                                <div class="answer-label">Оценочная стоимость</div>
                                <div class="answer-text">От {{detailedItem.priceFrom}}р до {{detailedItem.priceTo}}р</div>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-divider></v-divider>
                    <v-row >
                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="py-0 my-0">
                            <v-btn
                                    @click="setArchive(detailedItem.id)"
                                    outlined
                                    color="var(--color-red)"
                                    size="sm"
                            >
                                Отправить в архив
                            </v-btn>
                        </v-col>
                        <v-col cols="auto" class="py-0 my-0">
                            <v-btn
                                    dark
                                    color="var(--color-blue)"
                                    @click="redirectOrder"

                            >Перейти к заказу
                            </v-btn>
                        </v-col>
                        <b-col cols="auto" class="py-0 my-0">
                            <v-btn
                                    color="var(--color-2)"
                                    outlined
                                      @click="closeModal(false)"
                            >Отмена</v-btn>
                        </b-col>
                    </v-row>
                </template>
            </div>
            <div class="w-100 detailFooter" v-if="isArchive==false&&detailedItem!=null&&detailedItem.requestCategoryCode=='RC04'">
                <v-row >
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="py-0 my-0">
                        <v-btn
                               size="sm"
                               @click="setArchive(detailedItem.id)"
                               outlined
                               color="var(--color-red)"
                        >
                            Отправить в архив
                        </v-btn>
                    </v-col>
                    <v-col cols="auto" class="py-0 my-0">
                        <v-btn
                                class="cancel-btn"
                                outlined
                                color="var(--color-3)"
                                size="sm"
                                @click="closeModal(false)"
                        >
                            Отмена
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import requestDetail from './DetailsRequestData'
    import iconItem from '../icons.vue'
    export default {
        name: "DetailsTemplateModal",
        components: {requestDetail, iconItem},
        props:{
            detailedItem:Object,
            show:Boolean,
            isArchive:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                requestAnswerModel: {
                    requestId: null,
                    textAnswer: null,
                    priceFrom: null,
                    priceTo: null,
                },

            }
        },
        computed:{

        },
        methods:{
            onAcceptRequest() {
                this.$store.dispatch("Requests/acceptRequest", this.requestAnswerModel)
                    .then(() => {
                        this.$bvToast.toast("Вы откликнулись на заявку", {
                            variant: "success",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                        this.closeModal(true)
                    })
                    .catch(err => {
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка Отклика на заявку!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    })

            },

            reset() {
                for (var key in this.requestAnswerModel) {
                    this.requestAnswerModel[key] = null;
                }
                this.requestAnswerModel.requestId = this.detailedItem.id;
            },

            declineRequest(requestId) {
                this.$bvModal.msgBoxConfirm('Вы действительно хотите отказаться от заявки?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Отказаться',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            this.$store.dispatch("Requests/declineRequest", requestId).then(() => {
                                this.$bvToast.toast("Вы отказались от заявки", {
                                    variant: "warning",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                                this.closeModal(true);
                            }).catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка отказа от заявки!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })

            },

            closeModal(isSave) {
                this.$emit("close",isSave)
            },

            setArchive(requestId) {
                this.$bvModal.msgBoxConfirm('Вы действительно хотите отправить заявку в архив?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Подтвердить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            this.$store.dispatch("Requests/archive", requestId).then(() => {
                                this.closeModal(true);
                                this.$bvToast.toast(`Заказ успешно перемещен в архив`, {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                                this.$store.dispatch("Requests/getAchiveRequests")
                                    .catch(err=>{
                                        this.$bvToast.toast(err.message, {
                                            title: `Ошибка загрузки списка архивных заявок!`,
                                            variant: "danger",
                                            toaster: 'b-toaster-bottom-right',
                                            autoHideDelay: 3000,
                                            solid: true
                                        })
                                    })
                            }).catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка удаления заявки!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                        }
                    })

            },

            redirectOrder(){
                this.$router.push({name:"Orders"})
            }
        },
        watch:{
            show(value){
                if(value==true){
                    this.reset();
                }
            }
        }
    }
</script>

<style scoped>

    .client-name{
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        color: #1A2A3A;
    }

    .request-number {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: var(--text-color);
    }

    .request-date{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color:var(--color-2);
    }

    .answer-header{
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #1A2A3A;
        margin: 5px 0 10px 0;
    }

    .answer-label{
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 2px;
        color: var(--color-2);
    }

    .info-label{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        margin: 20px 0 30px 0;
        color:var(--color-2);
    }

    .answer-text{
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #1A2A3A;
    }
</style>